import React, { useContext } from 'react'
import { styled } from '../../../../lib/stitches'
import { Spacer } from '../../../core/Components'
import { gray15, gray2, gray7 } from '../../../platform/color'
import { UploadModalContext } from './index'

const StyledFooterContainer = styled('div', {
  display: 'flex',
  flexDirection: 'space-between',
  marginTop: '48px'
})

export const Button = styled('button', {
  all: 'unset',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  padding: '12px 32px',
  fontSize: '14px',
  lineHeight: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '500',
  borderRadius: '9999px',
  position: 'relative',
  transition: 'all 100ms ease',
  background: gray15,
  color: gray2,
  '&:hover': { opacity: '.8' },
  '&:active': {
    opacity: '1',
    transform: 'translateY(1px)'
  },
  '&:disabled': {
    opacity: '.5'
  },
  variants: {
    secondary: {
      true: {
        borderColor: gray7,
        borderWidth: '1px',
        borderStyle: 'solid',
        background: 'transparent',
        color: gray7,
        '&:hover': { background: 'rgba(0,0,0,.05)' }
      }
    },
    loading: {
      true: {
        color: 'transparent'
      }
    }
  }
})

const UploadModalFooter: React.FC<{ disableContinue?: boolean }> = ({ disableContinue }) => {
  const { stepForward, stepBack, stepIndex } = useContext(UploadModalContext)

  return (
    <StyledFooterContainer>
      {stepIndex > 0 && (
        <Button onClick={stepBack} secondary>
          Back
        </Button>
      )}
      <Spacer />
      <Button disabled={disableContinue} onClick={stepForward}>
        Continue
      </Button>
    </StyledFooterContainer>
  )
}

export default UploadModalFooter
